import {
    heroBars3,
    heroMagnifyingGlass,
    heroArrowRight,
    heroArrowPath,
    heroChevronLeft,
    heroChevronRight,
    heroChevronUp,
    heroChevronDown,
    heroXMark,
    heroMap,
    heroHome,
    heroHeart,
    heroQueueList,
    heroRadio,
    heroPencil,
    heroPhoto,
    heroArrowLeftCircle,
    heroCurrencyDollar,
    heroCalendarDays,
    heroChevronDoubleLeft,
    heroTrash,
    heroAdjustmentsHorizontal,
    heroClock,
    heroArrowsPointingOut,
    heroShare,
    heroEye,
    heroEyeSlash,
    heroCube,
    heroGlobeAmericas,
    heroPause,
    heroPlay,
    heroChatBubbleLeft,
    heroPhone,
    heroBars3BottomLeft,
    heroUserCircle,
    heroArrowTopRightOnSquare,
    heroCheck,
    heroPlus,
    heroMinus,
    heroDocumentDuplicate,
} from '@ng-icons/heroicons/outline';
import { heroCheckCircleSolid, heroXCircleSolid, heroHeartSolid } from '@ng-icons/heroicons/solid';
import { heroLockClosed } from '@ng-icons/heroicons/outline';

export const ICONS = {
    heroCalendarDays,
    heroBars3,
    heroMagnifyingGlass,
    heroArrowRight,
    heroArrowPath,
    heroChevronLeft,
    heroChevronRight,
    heroChevronDown,
    heroChevronUp,
    heroXMark,
    heroMap,
    heroHome,
    heroHeart,
    heroQueueList,
    heroCheckCircleSolid,
    heroRadio,
    heroPencil,
    heroXCircleSolid,
    heroHeartSolid,
    heroLockClosed,
    heroArrowTopRightOnSquare,
    heroCheck,
    heroPhoto,
    heroArrowLeftCircle,
    heroCurrencyDollar,
    heroChevronDoubleLeft,
    heroTrash,
    heroAdjustmentsHorizontal,
    heroClock,
    heroArrowsPointingOut,
    heroShare,
    heroEye,
    heroEyeSlash,
    heroCube,
    heroGlobeAmericas,
    heroPause,
    heroPlay,
    heroChatBubbleLeft,
    heroPhone,
    heroBars3BottomLeft,
    heroUserCircle,
    heroPlus,
    heroMinus,
    heroDocumentDuplicate,
};
